import { v4 as uuidv4 } from "uuid";

/**
 * Namespaced per app: several phase6 frontends share the www.phase-6.de origin, and one tab
 * must not carry the same id into two Sentry projects.
 */
export const SENTRY_SESSION_ID_KEY = "p6-diag-id:teacher-tools";

/**
 * Random per-tab id that identifies no one. sessionStorage on purpose (not localStorage, no cookie): dies
 * with the tab, so no recognition across visits; replay already writes there, so no new kind of device access.
 * Storage blocked (e.g. Safari private mode) → fresh id on every call.
 */
export const getSentrySessionId = (): string => {
    try {
        const stored = sessionStorage.getItem(SENTRY_SESSION_ID_KEY);
        if (stored) return stored;

        const id = uuidv4();
        sessionStorage.setItem(SENTRY_SESSION_ID_KEY, id);
        return id;
    } catch {
        return uuidv4();
    }
};
